import { render, staticRenderFns } from "./TransplantRegistration.vue?vue&type=template&id=0779860a"
import script from "./TransplantRegistration.vue?vue&type=script&lang=js"
export * from "./TransplantRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports